import * as React from 'react';
import { FC, useState, Fragment } from 'react';
import {
    List, Datagrid,
    TextField, EditButton,
    useNotify, useDelete,
    ListProps, Button as RAButton,
    useRecordContext,
    TextInput
} from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { IDirectoryContact } from '../types/types';
import useAuthorize from '../hooks/useAuthorize';
import { UserRole } from '../types/types';

const ContactFilter = [
    <TextInput label="Search" source="contact_search" resettable alwaysOn />,
];

const DeleteWithConfirmButton: FC = () => {
    const record = useRecordContext<IDirectoryContact>();
    const [deleteOne, { isLoading }] = useDelete();
    const [open, setOpen] = useState(false);
    const notify = useNotify();

    const handleDelete = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const confirmDelete = async () => {
        await deleteOne('directorycontacts', { id: record.id });
        notify('resources.directorycontacts.notification.deleted', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'Directory Contact' }
        });
        setOpen(false);
    };

    return (
        <Fragment>
            <RAButton
                label="Delete"
                onClick={handleDelete}
                startIcon={<DeleteIcon />}
                disabled={isLoading}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this directory contact?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={confirmDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export const DirectoryContactList: FC<ListProps> = (props) => {
    useAuthorize([UserRole.Admin]);
    return (
        <List
            filters={ContactFilter}
            {...props}
            sort={{ field: 'display_priority', order: 'DESC' }}
            perPage={25}
        >
            <Datagrid bulkActionButtons={false}>
                <TextField source="display_priority" label="Priority" sortable />
                <TextField source="company_name" label="Company Name" sortable />
                <TextField source="first_name" label="First Name" />
                <TextField source="last_name" label="Last Name" />
                <TextField source="email_address" label="Email" />
                <TextField source="phone_mobile" label="Mobile" />
                <EditButton />
                <DeleteWithConfirmButton />
            </Datagrid>
        </List>
    );
};
